import { Typography } from '@design-system/components/typography/typography';
import { Col } from '@design-system/components/grid/grid';
import { PriceForm } from './PriceForm';
import { Alert } from '@design-system/components/alert/alert';
import { errorWrapper } from './PriceForm.css';
import { Control } from 'react-hook-form';
import { BundleFormValues } from '../../viewModel/priceFormSchemas';
import { PriceRangeType } from '../../viewModel/editBundle.vm.mapper';
import { SubscriptionBundleVMDispatcher } from '../../viewModel/subscriptionBundles.viewModel';

export type PriceProps = {
  control: Control<BundleFormValues, any, BundleFormValues>;
  transformPrice: (value: string, type: PriceRangeType) => void;
  error?: string;
  price: {
    disabled: {
      monthly: boolean;
      annual: boolean;
    };
  };
  dispatch: SubscriptionBundleVMDispatcher;
};

export const Price = ({ error, ...p }: PriceProps) => (
  <Col center gap="l">
    <Typography variant="headline" size="large">
      Exclusive Subscription price
    </Typography>
    <Typography variant="body" size="large">
      Setup your price and if you want to offer a 7-day free trial. You will be
      able to change those settings anytime.
    </Typography>
    {error && (
      <div className={errorWrapper}>
        <Alert variant="error" title={error} />
      </div>
    )}
    <PriceForm {...p} />
  </Col>
);
